import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Typo } from 'uikit/content';

import VideoImage from '../images/default_on_demand_cover.svg';

import styles from '../styles/videoTopicWidgetItem.module.scss';

const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

const VideoTopicWidgetItem = ({ name, duration, picture, id, isActive }) => (
  <Link to={`/student/videos/on-demand/${id}`}>
    <div
      className={classnames(styles.listItem, {
        [styles.isActive]: isActive,
      })}
    >
      <div className={styles.listItemMeta}>
        <div className={styles.duration}>{formatDuration(duration)}</div>
        <div className={styles.listItemImageContainer}>
          {picture?.url?.w550 ? (
            <img className={styles.listItemImage} src={picture?.url?.w550} alt="" />
          ) : (
            <div className={styles.listItemImage}>
              <VideoImage />
            </div>
          )}
        </div>
      </div>
      <div className={styles.listItemTitle}>
        <Typo variant="s02" weight="medium">
          {name}
        </Typo>
      </div>
    </div>
  </Link>
);

VideoTopicWidgetItem.defaultProps = {
  name: '',
  duration: 0,
  isActive: false,
  picture: {
    alt_text: '',
    url: {
      w550: '',
    },
  },
};

VideoTopicWidgetItem.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  duration: PropTypes.number,
  picture: PropTypes.shape({
    alt_text: PropTypes.string,
    url: PropTypes.shape({
      w550: PropTypes.string,
    }),
  }),
  isActive: PropTypes.bool,
};

export default VideoTopicWidgetItem;
